<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table  hide-upsert :config="config" title="Press" @update="update" @link="link">
          <template slot="headerActions">
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" color="secondary" @click="newEntity()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>New Press</span>
            </v-tooltip>
          </template>
        </app-table>
        
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import config from './config_index.js'
import { mapActions } from "vuex";
import store from '../../store'

export default {
  data () {
    return { 
      config,
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    ...mapActions("app", ["getConfig"]),
    update(item) {
      this.$router.push('/press/' + item.id)
    },
    newEntity() {
       this.$router.push("/press");
    },
    link(item) {

        const typeMap = {
          'Intervista' : 'intervista-dettaglio',
          'Focus on' : 'focus-on-dettaglio'
        }

        window.open(store.getters.siteUrl + '/' + typeMap[item.type] + '/' + item.semantic_url, '_blank')
    }
  }
}
</script>
